import React, { useEffect, useState } from "react";
import img1 from "../../assets/images/aadhaar.png";
import img2 from "../../assets/images/smalladhaar.jpeg";
import preImg from "../../assets/images/img_icon.png";
import ModalComponent from "../ModalComponent/Modal";
import { Upload } from "@arco-design/web-react";
import { IconPlus } from "@arco-design/web-react/icon";


function OVDComponent({ responseData = '', setUploadSide,previewImg, previewIsImage }) {

  const [formattedResponse, setFormattedResponse] = useState([]);
  const [isImage, setIsImage] = useState(true);
  const [imagePreview, setImagePreview] = useState({ data: "", type: "", name: "" })
  const [visible, setVisible] = useState(false)
  const handlePreview = async (data) => {

    setImagePreview((pre) => ({ data: data?.src, type: "img", name: data?.label }))
    setVisible(true)
  }


  const [file, setFile] = React.useState();
  const cs = `arco-upload-list-item${file && file.status === 'error' ? ' is-error' : ''}`;

  const handleClose = () => {
    setVisible(false)
  }
   useEffect(() => {
    setIsImage(previewIsImage);
   },[previewIsImage])
  useEffect(() => {
    let response = responseData?.result ? JSON.parse(responseData?.result).message : responseData?.message
    
    if (response) {
      try {
        const resultObject = JSON.parse(response);
        const labels = Object.values(resultObject?.class_names); // changes made according to the new response structure
        const formattedData = resultObject?.image.map((item, index) => (
          // //console.log("looooooooooooo",labels[index].includes("_")?labels[index].replace("_", " "):labels[index],typeof(labels[index]),labels[index]),
          {
            id: index,
            src: `data:image/png;base64,${item}`,
            label: labels[index]?.replaceAll("_", " "),
          }));
        setFormattedResponse(formattedData);
      } catch (err) {
        console.error(err);
      }
    }
  }, [responseData]);

  if (!responseData) {
    return null; // Render nothing if responseData is not available yet
  }
  return (
    <>
      <div className="bx1 scrollbar1  ms-0 ms-md-3 row rounded h-100   p-2">
        <div className="row px-0 mx-0">
          <div className="bd_dotted_0 bd_dotted_md bd_master2 border-bottom-0 border-start-0 border-top-0 col-12 col-md-5">
            <div className="px-0 px-sm-2">
              <h2 className="font_16 fw-bold text-center mt-2 mb-2">Uploaded data</h2>
              {isImage ?
                <div className=" bg_lightdark upload_thumb1 object_fit_contain w-100 mt-4  p-1 br_15 " onClick={() => handlePreview({ src: previewImg, label: "UPLOADED DATA" })}>
                  <img src={previewImg || preImg} className="object_fit_contain w-100 h-100  p-3" />
                </div>
              :
                <div className="bg_lightdark upload_thumb1 object_fit_contain w-100 mt-4  p-1 br_15">
                  <iframe
                    title="Document Preview"
                    src={previewImg} 
                    style={{ width: "100%", height: "calc(100vh - 274px)", border: "none" }}
                  />
                </div>
              }
              <div className='arco_custom_upload d-flex justify-content-center pt-4'>
                {/* <Upload> */}
                <div className={cs}>

                  <div className='bg_master2 px-4 br_5  py-2 cursor-pointer' onClick={() => { setUploadSide(true) }}>
                    {/* <div className='acro_custom_icon d-flex align-items-center justify-content-center'> */}
                    <div className='text-white ms-2'>Try another file</div>
                    {/* </div> */}
                  </div>

                </div>
                {/* </Upload> */}
              </div>
            </div>
          </div>
          <div className="col-12 col-md-7">
            <div className="extracted_data_section pt-0 py-2 overflow-auto scrollbar1 px-3 px-md-3 ">
              <h2 className="font_16 fw-bold text-center mt-2 mb-2">Extracted data</h2>
              <div className="mt-4">
                <div className="row  bx1_img_box1_demo bx1_img_box1 ">
                  {formattedResponse.map((itm) => (
                    // //console.log(itm),
                    <div className="col-12 col-md-6 mb-3 px-0 px-md-2">
                      <div className="bg_lightdark upload_thumb object_fit_contain w-100   p-1 br_15 " onClick={() => handlePreview(itm)}>
                        <h2 className="py-1 mb-0 font_13 font_600 ps-3 text-center">{itm.label}</h2>
                        <img src={itm.src} className="  object_fit_contain w-100 h-100  p-3" />
                      </div>
                    </div>
                  ))}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalComponent show={visible} imgPreview={imagePreview} handleClose={handleClose} />
    </>
  );
}

export default OVDComponent;
